import React, { ReactNode } from 'react';
import ApartmentIcon from '@mui/icons-material/Apartment';
import LayersIcon from '@mui/icons-material/Layers';
import { Box } from '@mui/material';

import { notNullish } from '@paragon/utilities';

import {
  getActiveLevelOrNull,
  getVisibleBuildingOrNull,
  getVisibleLevelGuids,
} from '../../../../store/selectors/layoutDataSelectors';
import { useAppSelector } from '../../../hooks';

export function ScopeDescription(): ReactNode {
  const visibleBuilding = useAppSelector(getVisibleBuildingOrNull);
  const activeLevel = useAppSelector(getActiveLevelOrNull);

  const visibleLevelsSet = useAppSelector(getVisibleLevelGuids);

  if (visibleBuilding == null) return 'Buildings & Levels';

  const visibleLevelGuids = [...visibleLevelsSet].filter(notNullish);

  if (activeLevel == null) {
    return (
      <Wrapper>
        <BuildingName name={visibleBuilding.name} />
        <LevelName name="No Active Level" />
      </Wrapper>
    );
  }

  const otherVisibleLevels = visibleLevelGuids.filter((guid) => guid !== activeLevel.guid);
  const levelDisplayName = otherVisibleLevels.length > 0 ? `${activeLevel.name} (+)` : activeLevel.name;

  return (
    <Wrapper>
      <BuildingName name={visibleBuilding.name} />
      <LevelName name={levelDisplayName} />
    </Wrapper>
  );
}

function Wrapper({ children }: React.PropsWithChildren) {
  return (
    <Box component="span" sx={{ display: 'flex', gap: 1 }}>
      {children}
    </Box>
  );
}

function BuildingName(props: { name: string }) {
  return (
    <Box component="span" sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
      <ApartmentIcon fontSize="inherit" />
      {props.name}
    </Box>
  );
}

function LevelName(props: { name: string }) {
  return (
    <Box component="span" sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
      <LayersIcon fontSize="inherit" />
      {props.name}
    </Box>
  );
}
